import { createActionGroup, props } from '@ngrx/store';
import { TypeOfTreatmentEntity } from '../../../../entities/mdqx/doctor/type-of-treatment.entity';
import { MutationChangeTypeoftreatmentArgs } from '../../../../mdqx-graphql-types';

export const TypeOfTreatmentActions = createActionGroup({
    source: 'typeOfTreatment',
    events: {
        'Load Success': props<{ Payload: TypeOfTreatmentEntity[] }>(),
        'Load Request': props<{ Payload?: {} /*todo*/ }>(),
        'Load Failure': props<{ Errors: any; ToasterMessage?: string }>(),

        // 'Put Request': props<{ Payload: {}/*todo*/ }>(),
        'Put Failure': props<{ Errors: any; ToasterMessage?: string }>(),
        'Put Success': props<{ Payload: TypeOfTreatmentEntity[] }>(),

        'Change Request': props<{ Payload: MutationChangeTypeoftreatmentArgs }>(),
        'Change Failure': props<{ Errors: any; ToasterMessage?: string }>(),
        'Change Success': props<{ Payload: TypeOfTreatmentEntity }>(),

        'delete Request': props<{ Payload: MutationChangeTypeoftreatmentArgs }>(),
        'delete Failure': props<{ Errors: any; ToasterMessage?: string }>(),
        'delete Success': props<{ Payload: number }>(),
    },
});
